/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { postApi } from "../../../redux/api";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button, Col, Row } from "@themesberg/react-bootstrap";
import { Alert, Modal } from "react-bootstrap";
import CustomButton from "../../../components/CustomButton";
import { Routes } from "../../../routes";
import toast from "react-hot-toast";
import BackButton from "../../../components/BackButton";
import useQuery from "../../../hooks/useQuery";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import SupportingDocumentsPv from "./SupportingDocuments";
import { OAGOFFICE } from "./PVReviewIndex";
import Trailbalance from "./HtmlPvPdf";
import { ExactPVPDF } from "./ExactPVPDF";
import { pdf } from "@react-pdf/renderer";
import { saveAs } from "file-saver";

export default function PvPdfPage() {
  const user = useSelector((state) => state.auth.user);
  const isSelfSustained = user.isSelfSustained;
  const query = useQuery();
  const pv_code = query.get("approval_no");
  const actualPvCode = query.get("pv_code") || "";
  const approval_type = query.get("approval_type");
  const history = useNavigate();
  const location = useLocation();
  const isReport = location.pathname.includes("report");
  const isReview = location.pathname.includes("review");
  const isEdit = location.pathname.includes("generated");
  // const isAdCheck = location.pathname.includes("checkad");
  const isCheck = location.pathname.includes("check");
  const isApprove = location.pathname.includes("approve");
  const isDAG = isApprove && user.mda_name === OAGOFFICE;
  const isIndividual = location.pathname.includes("individual");

  const [pvInfo, setPvInfo] = useState([]);
  const [taxes, setTaxes] = useState([]);
  const [multiplePVsData, setMultiplePVsData] = useState(null);
  const [isCapitalProject, setIsCapitalProject] = useState(false);
  const [capitalProjectData, setCapitalProjectData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [approving, setApproving] = useState(false);
  const [commentExpanded, setCommentExpanded] = useState(false);
  const [commentObj, setCommentObj] = useState({});
  const [error, setError] = useState(null);
  const [downloadingPdf, setDownloadingPdf] = useState(false);

  useEffect(() => {
    // Validate required parameters
    if (!pv_code) {
      setError("Missing approval number parameter");
      toast.error("Invalid URL: Missing approval number");
      return;
    }

    if (approval_type === "undefined" || approval_type === null) {
      console.warn("Approval type is undefined, proceeding with default handling");
    }

    if (pv_code) {
      setDataLoading(true);
      setError(null);
      
      // Check if this is a capital project first
      if (approval_type === "Capital") {
        // Use the new capital project API
        postApi(`get_pv_data`, {
          approval_no: pv_code,
          pv_code: actualPvCode,
        })
          .then((data) => {
            if (data?.success && data?.result) {
              setIsCapitalProject(true);
              setCapitalProjectData(data.result);
              setPvInfo(data.result.mainPV ? [data.result.mainPV] : []);
              setTaxes(data.result.taxes || []);
            }
          })
          .catch((err) => {
            console.log(err);
            toast.error("Failed to load capital project PV data");
          })
          .finally(() => setDataLoading(false));
      } else {
        // Use existing logic for standard PVs
        if (user && user.mda_name === OAGOFFICE) {
          postApi(`get_pv_collection`, {
            form: {
              query_type: isIndividual
                ? "select_by_pvcode"
                : isReport
                ? "pv_by_approval_report"
                : "pv_by_approval",
              approval_no: pv_code,
              pv_status: isApprove
                ? "Reviewed"
                : isReview
                ? /*"AD Checked" : isAdCheck ?*/ "Checked"
                : isEdit
                ? "Created - Returned"
                : "Pending",
              mda_code: user?.mda_code,
              pv_code: actualPvCode,
            },
          })
            .then((data) => {
              if (data?.result && data?.result.length) {
                setPvInfo(data?.result);
                const filteredStatus = `${
                  isApprove ? "Reviewed" : isReview ? "Checked" : "Pending"
                } - Returned`;
                let comm = data?.result[0].history.filter(
                  (a) => a?.pv_status === filteredStatus
                );
                if (comm && comm.length) {
                  setCommentObj(comm[0]);
                }
              }
            })
            .catch((err) => {
              console.log(err);
              toast.error("Failed to load PV data");
            })
            .finally(() => setDataLoading(false));
        } else {
          postApi(`get_pv_collection`, {
            form: {
              query_type: isIndividual
                ? "select_by_pvcode"
                : isReport
                ? "pv_by_approval_report"
                : "pv_by_approval",
              approval_no: pv_code,
              pv_status: isApprove
                ? "Reviewed"
                : isReview
                ? "Checked"
                : isEdit
                ? "Created - Returned"
                : "Pending",
              mda_code: user?.mda_code,
              pv_code: actualPvCode,
            },
          })
            .then((data) => {
              if (data?.result && data?.result.length) {
                setPvInfo(data?.result);
                const filteredStatus = `${
                  isApprove ? "Reviewed" : isReview ? "Checked" : "Pending"
                } - Returned`;
                let comm = data?.result[0].history.filter(
                  (a) => a?.pv_status === filteredStatus
                );
                if (comm && comm.length) {
                  setCommentObj(comm[0]);
                }
              }
            })
            .catch((err) => {
              console.log(err);
              toast.error("Failed to load PV data");
            })
            .finally(() => setDataLoading(false));
        }
      }
    }
  }, [pv_code, isIndividual, isReport, isApprove, user.mda_name, actualPvCode, approval_type]);

  useEffect(() => {
    if (!pv_code) {
      return; // Don't make API call if pv_code is missing
    }
    
    setDataLoading(true);
    postApi(`get_pv_collection`, {
      form: {
        query_type: "taxes_by_approval",
        approval_no: pv_code,
      },
    })
      .then((data) => {
        console.log("Multiple PVs data", data);
        if (data?.result && data?.result.type === 'multiple_pvs') {
          // Handle new multiple PVs structure
          const { main_pv, tax_pvs, taxes } = data.result;
          setPvInfo([main_pv]); // Set main PV as primary display
          setTaxes(taxes || []);
          setMultiplePVsData(data.result); // Store complete multiple PVs data
        } else if (data?.result && data?.result.length) {
          // Handle legacy single taxes response
          setTaxes(data?.result);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Failed to load taxes data");
      })
      .finally(() => setDataLoading(false));
  }, [pv_code]);

  const toggleWarning = () => setShowWarning((p) => !p);

  const handleReturn = async () => {
    setApproving(true);
    for (let pv of pvInfo) {
      await postApi(`post_pv_collection`, {
        form: {
          query_type: "update_cash_backing",
          pv_code: pv.pv_code,
          approval_no: pv.pv_code,
          pv_status: isReview
            ? "Pending - Returned"
            : isCheck
            ? "Created - Returned"
            : "Checked - Returned",
          userId: user.username,
          remarks,
        },
      });
    }

    toggleWarning();
    toast.success("PV Returned Successfully!");
    if (isReview) {
      history(Routes.pv.pvReviewIndex);
    } else if (isCheck) {
      history(Routes.pv.pvCheckIndex);
    } else {
      history(Routes.pv.pvApproveIndex);
    }
  };

  // const getpvHistory = useCallback(() => {
  //   postApi(`get_pv_collection`, {
  //     query_type: "get_history",
  //     pv_code: pv_code,
  //   })
  //     .then((data) => {
  //       console.log("History data", data);
  //       if (data?.result && data?.result.length) {
  //         setpvHistory(data.result);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("This is the Error that occurred", err);
  //     });
  // }, [pv_code]);

  // useEffect(() => {
  //   getpvHistory();
  // }, [getpvHistory]);

  useEffect(() => {
    if (pv_code) {
      setDataLoading(true);
      postApi(`get_pv_collection`, {
        form: {
          query_type: "get_history",
          approval_no: actualPvCode,
        },
      })
        .then((data) => {
          console.log("My History", data);
          // History data loaded but not used in current implementation
        })
        .catch((err) => {
          console.log(err);
          toast.error("Failed to load PV history");
        })
        .finally(() => setDataLoading(false));
    }
  }, [pv_code, actualPvCode]);

  const handleApprove = async () => {
    setApproving(true);
    for (let pv of pvInfo) {
      // Determine pv_status based on conditions
      let pvStatus;
      let notif_key;
      
      // Check if user is from self-accounting MDA and is approving
      if ((isSelfSustained === 'true' || isSelfSustained === true) && isApprove) {
        // Self-accounting MDA approval
        pvStatus = "SA_approved";
      } else if (isDAG) {
        // DAG approval
        pvStatus = "DAG Approved";
        notif_key = "Receiving Office"
      } else if (isReview) {
        pvStatus = "Reviewed";
        notif_key = "Approve PV"
      } else if (isCheck) {
        pvStatus = "Checked";
        notif_key = "Review PV"
      } else {
        pvStatus = "Approved";
        notif_key = "Receiving Office"
      }

      await postApi(`post_pv_collection`, {
        form: {
          query_type: "update_cash_backing",
          pv_code: pv.pv_code,
          approval_no: pv.pv_code,
          pv_status: pvStatus,
          userId: user.username,
          remarks,
          notif_key
        },
      });
    }

    // setTimeout(() => {
    toast.success("PV Approved Successfully!");
    if (isReview) {
      history(Routes.pv.pvReviewIndex);
    } else if (isCheck) {
      history(Routes.pv.pvCheckIndex);
    } else {
      history(Routes.pv.pvApproveIndex);
    }
    // }, 2000);
  };

  const downloadPdf = async () => {
    try {
      setDownloadingPdf(true);
      
      // Determine which data structure to use
      let pdfData = null;
      let pdfTaxes = taxes || [];
      let pdfMultiplePVsData = null;
      
      // Check if we have multiple PVs data
      if (multiplePVsData) {
        pdfMultiplePVsData = multiplePVsData;
      } else if (taxes && taxes.length > 0 && pvInfo && pvInfo.length > 0) {
        // Create multiple PVs structure from current data
        const totalTaxAmount = taxes.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0);
        const grossAmount = parseFloat(pvInfo[0]?.amount || 0);
        const netAmount = grossAmount - totalTaxAmount;
        
        pdfMultiplePVsData = {
          main_pv: {
            ...pvInfo[0],
            pv_type: 'main',
            original_amount: grossAmount,
            net_amount: netAmount,
            tax_details: taxes
          },
          tax_pvs: taxes.map((tax, index) => ({
            ...pvInfo[0],
            pv_code: `${pvInfo[0]?.pv_code}-TAX-${index + 1}`,
            pv_type: 'tax',
            tax_name: tax.description,
            tax_amount: tax.amount,
            amount: tax.amount,
            narration: `Tax: ${tax.description}`,
            description: `Tax: ${tax.description}`,
            parent_pv_code: pvInfo[0]?.pv_code,
            tax_details: [tax]
          })),
          total_pvs: 1 + taxes.length,
          taxes: taxes,
          type: 'multiple_pvs'
        };
      } else {
        pdfData = pvInfo;
      }
      
      // Use the ExactPVPDF component that matches HTML layout exactly
      const blob = await pdf(
        <ExactPVPDF 
          data={pdfData} 
          taxesApplied={pdfTaxes} 
          user={user}
          isCapitalProject={isCapitalProject}
          capitalProjectData={capitalProjectData}
          multiplePVsData={pdfMultiplePVsData}
        />
      ).toBlob();
      
      const fileName = pdfMultiplePVsData 
        ? `pv-${pv_code}-with-taxes.pdf`
        : `pv-${pv_code || 'document'}.pdf`;
      
      saveAs(blob, fileName);
      
      const pvCount = pdfMultiplePVsData ? pdfMultiplePVsData.total_pvs : 1;
      toast.success(`PDF downloaded successfully! (${pvCount} PV${pvCount > 1 ? 's' : ''})`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast.error("Failed to generate PDF. Please try again.");
    } finally {
      setDownloadingPdf(false);
    }
  };

  if (dataLoading) {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
              <p className="mt-3 text-muted">Loading PV data...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <Alert variant="danger">
              <Alert.Heading>Error Loading PV Report</Alert.Heading>
              <p>{error}</p>
              <hr />
              <div className="d-flex justify-content-between">
                <BackButton />
                <Button 
                  variant="outline-danger" 
                  onClick={() => window.location.reload()}
                >
                  Retry
                </Button>
              </div>
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  if (pvInfo && pvInfo.length) {
    return (
      <div className="pv-paxper-view">
        {/* {JSON.stringify({isAdCheck})}..xx */}
        {/* {JSON.stringify({commentObj,
          ll: `${isApprove ? "Reviewed" : isReview ? "Checked" : "Pending"} - Returned`
        })}..xx */}
        <div className="pv-heajder-controls">
          <BackButton num={-1} />
          {isEdit ? (
            <div className="mb-1">
              <button
                className="pv-action-button me-2 py-2 rounded"
                onClick={() =>
                  history(
                    `${Routes.cashBacking.releaseCollectionPDF}?approval_no=${encodeURIComponent(pv_code)}`
                  )
                }
              >
                <FontAwesomeIcon icon={faEye} className="me-1" />
                View Release Document
              </button>
              <Button
                onClick={() => history(`${Routes.pv.editnewPv}?approval_no=${encodeURIComponent(pv_code)}`)}
              >
                <FontAwesomeIcon icon={"pencil"} size="lg" />
                Edit PV
              </Button>
            </div>
          ) : null}
        </div>
        
        {/* Paper Document Container */}
        <div className="pv-pxaper-container">
          <div className="pv-paper-sheet">
            {/* {JSON.stringify(pvInfo)} */}
            {isEdit ? (
              <Row>
                {/* <p>{pv_code}, {approval_no}</p> */}
                <Col md={12}>
                  {commentObj?.remarks && commentObj.remarks !== "" ? (
                    <Alert className="pv-comment-alert">
                      <h6>Comments:</h6>

                      {commentObj.remarks.length > 80 && !commentExpanded ? (
                        <p>
                          {commentObj.remarks?.substr(0, 80)}{" "}
                          <span
                            style={{ cursor: "pointer" }}
                            className="text-info"
                            onClick={() => setCommentExpanded(true)}
                          >
                            See more
                          </span>
                        </p>
                      ) : (
                        <p>{commentObj.remarks}</p>
                      )}

                      <div> - {commentObj.fullname}</div>
                    </Alert>
                  ) : null}
                </Col>
              </Row>
            ) : null}

            {isReview || isCheck || isApprove ? (
              <div className="pv-action-section">
                <Row>
                  <Col md={7}>
                    {commentObj?.remarks && commentObj.remarks !== "" ? (
                      <Alert className="pv-comment-alert">
                        <h6>Comments:</h6>

                        {commentObj.remarks.length > 80 && !commentExpanded ? (
                          <p>
                            {commentObj.remarks?.substr(0, 80)}{" "}
                            <span
                              style={{ cursor: "pointer" }}
                              className="text-info"
                              onClick={() => setCommentExpanded(true)}
                            >
                              See more
                            </span>
                          </p>
                        ) : (
                          <p>{commentObj.remarks}</p>
                        )}

                        <div> - {commentObj.fullname}</div>
                      </Alert>
                    ) : null}
                  </Col>

                  <Col md={5} className="text-right">
                    <Button
                      className="btn-danger me-2 my-2"
                      onClick={toggleWarning}
                    >
                      Return
                    </Button>
                    <Button onClick={handleApprove}>Approve</Button>
                  </Col>
                </Row>
              </div>
            ) : null}

            {approving ? (
              <div className="pv-loading-overlay">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Processing...</span>
                </div>
                <p className="mt-2">Please wait...</p>
              </div>
            ) : null}

            <Row>
              <Col md={8}>
                {/* {JSON.stringify(isSelfSustained)} */}
                {/* <PDFViewer
                  style={{
                    width: "100%",
                    height: 1000,
                  }}
                > */}
                <div className="pv-document-controls">
                  <Button 
                    size="sm" 
                    className="my-2 pv-download-btn" 
                    onClick={downloadPdf}
                    disabled={downloadingPdf}
                  >
                    {downloadingPdf ? (
                      <>
                        <div className="spinner-border spinner-border-sm me-2" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        Generating PDF...
                      </>
                    ) : (
                      <>
                        <FontAwesomeIcon icon={faEye} className="me-1" />
                        Download PV PDF
                      </>
                    )}
                  </Button>
                </div>
                
                <div className="pv-document-wrapper">
                  {isCapitalProject && capitalProjectData ? (
                    <CapitalProjectPVView 
                      capitalProjectData={capitalProjectData}
                      user={user}
                    />
                  ) : multiplePVsData ? (
                    <MultiplePVsView 
                      multiplePVsData={multiplePVsData}
                      user={user}
                    />
                  ) : taxes && taxes.length > 0 ? (
                    // If we have taxes but no multiplePVsData, create it from current data
                    <MultiplePVsView 
                      multiplePVsData={{
                        main_pv: {
                          ...pvInfo[0],
                          pv_type: 'main',
                          original_amount: pvInfo[0]?.amount,
                          net_amount: parseFloat(pvInfo[0]?.amount || 0) - taxes.reduce((sum, tax) => sum + parseFloat(tax.amount || 0), 0),
                          tax_details: taxes
                        },
                        tax_pvs: taxes.map((tax, index) => ({
                          ...pvInfo[0],
                          pv_code: `${pvInfo[0]?.pv_code}-TAX-${index + 1}`,
                          pv_type: 'tax',
                          tax_name: tax.description,
                          tax_amount: tax.amount,
                          amount: tax.amount,
                          narration: `Tax: ${tax.description}`,
                          description: `Tax: ${tax.description}`,
                          parent_pv_code: pvInfo[0]?.pv_code,
                          tax_details: [tax]
                        })),
                        total_pvs: 1 + taxes.length,
                        taxes: taxes,
                        type: 'multiple_pvs'
                      }}
                      user={user}
                    />
                  ) : (
                    <Trailbalance
                      form={{}}
                      user={user}
                      data={pvInfo}
                      taxesApplied={taxes}
                      isMultiplePVs={false}
                      showTaxSummary={false}
                    />
                  )}
                </div>
                {/* </PDFViewer> */}
              </Col>

              <Col md={4}>
                <div className="pv-supporting-docs">
                  <SupportingDocumentsPv pvInfo={pvInfo} />
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Modal remains the same */}
        <Modal show={showWarning} onHide={toggleWarning} size="md">
          <Modal.Header>
            <h4>Please provide reason for return</h4>
          </Modal.Header>
          <Modal.Body>
            <textarea
              className="form-control"
              placeholder="Reason for return"
              rows={10}
              value={remarks}
              onChange={({ target: { value } }) => setRemarks(value)}
            />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger" onClick={toggleWarning}>
              Cancel
            </button>
            <CustomButton onClick={handleReturn}>Return</CustomButton>
          </Modal.Footer>
        </Modal>

        {/* Paper-like styling */}
        <style jsx>{`
          .pv-paper-view {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
            padding: 20px 0;
          }
          
          .pv-header-controls {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
          }
          
          .pv-action-button {
            background-color: #ffc107;
            border: none;
            color: #212529;
            padding: 8px 16px;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .pv-action-button:hover {
            background-color: #e0a800;
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }
          
          .pv-paper-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 20px;
          }
          
          .pv-paper-sheet {
            background: #ffffff;
            border-radius: 12px;
            box-shadow: 
              0 4px 6px rgba(0, 0, 0, 0.07),
              0 1px 3px rgba(0, 0, 0, 0.1),
              inset 0 1px 0 rgba(255, 255, 255, 0.1);
            padding: 40px;
            margin-bottom: 30px;
            position: relative;
            border: 1px solid #e1e5e9;
          }
          
          .pv-paper-sheet::before {
            content: '';
            position: absolute;
            top: 0;
            left: 60px;
            width: 2px;
            height: 100%;
            background: linear-gradient(to bottom, #ff6b6b 0%, #ff6b6b 50%, transparent 50%);
            background-size: 2px 20px;
            opacity: 0.3;
          }
          
          .pv-paper-sheet::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 40px;
            background: repeating-linear-gradient(
              90deg,
              transparent,
              transparent 19px,
              #e1e5e9 19px,
              #e1e5e9 21px
            );
            opacity: 0.5;
          }
          
          .pv-comment-alert {
            background: #fff3cd;
            border: 1px solid #ffeaa7;
            border-radius: 8px;
            padding: 15px;
            margin-bottom: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }
          
          .pv-action-section {
            background: #f8f9fa;
            border-radius: 8px;
            padding: 20px;
            margin-bottom: 30px;
            border: 1px solid #dee2e6;
          }
          
          .pv-loading-overlay {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: rgba(255, 255, 255, 0.95);
            padding: 30px;
            border-radius: 12px;
            text-align: center;
            box-shadow: 0 8px 25px rgba(0,0,0,0.15);
            z-index: 1000;
          }
          
          .pv-document-controls {
            margin-bottom: 20px;
            padding-bottom: 15px;
            border-bottom: 2px solid #e9ecef;
          }
          
          .pv-download-btn {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            border: none;
            color: white;
            padding: 10px 20px;
            border-radius: 6px;
            font-weight: 500;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }
          
          .pv-download-btn:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
          }
          
          .pv-document-wrapper {
            background: #ffffff;
            border: 2px solid #e9ecef;
            border-radius: 8px;
            padding: 20px;
            box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
            min-height: 800px;
          }
          
          .pv-supporting-docs {
            background: #f8f9fa;
            border: 1px solid #dee2e6;
            border-radius: 8px;
            padding: 20px;
            box-shadow: 0 2px 4px rgba(0,0,0,0.05);
          }
          
          /* Responsive adjustments */
          @media (max-width: 768px) {
            .pv-paper-view {
              padding: 10px 0;
            }
            
            .pv-header-controls {
              flex-direction: column;
              gap: 15px;
              align-items: stretch;
            }
            
            .pv-paper-container {
              padding: 0 10px;
            }
            
            .pv-paper-sheet {
              padding: 20px;
              margin-bottom: 20px;
            }
            
            .pv-paper-sheet::before {
              left: 30px;
            }
            
            .pv-action-section {
              padding: 15px;
            }
            
            .pv-document-wrapper {
              padding: 15px;
            }
            
            .pv-supporting-docs {
              margin-top: 20px;
              padding: 15px;
            }
          }
          
          /* Print styles */
          @media print {
            .pv-paper-view {
              background: white;
            }
            
            .pv-header-controls,
            .pv-action-section,
            .pv-document-controls {
              display: none;
            }
            
            .pv-paper-sheet {
              box-shadow: none;
              border: none;
              padding: 0;
            }
            
            .pv-paper-sheet::before,
            .pv-paper-sheet::after {
              display: none;
            }
          }
        `}</style>
      </div>
    );
  } else {
    return (
      <div className="pv-paper-view">
        <div className="pv-paper-container">
          <div className="pv-paper-sheet">
            <Alert variant="warning">
              <Alert.Heading>No PV Data Found</Alert.Heading>
              <p>No payment voucher data was found for the provided approval number: <strong>{pv_code}</strong></p>
              <hr />
              <div className="d-flex justify-content-between">
                <BackButton />
                <Button 
                  variant="outline-warning" 
                  onClick={() => window.location.reload()}
                >
                  Refresh
                </Button>
              </div>
            </Alert>
          </div>
        </div>
      </div>
    );
  }
}

// Multiple PVs View Component
const MultiplePVsView = ({ multiplePVsData, user }) => {
  const [activeTab, setActiveTab] = useState('main');
  
  if (!multiplePVsData) {
    return <div>No multiple PVs data available</div>;
  }

  const { main_pv, tax_pvs = [], taxes = [], total_pvs } = multiplePVsData;

  return (
    <div className="multiple-pvs-container">
      <div className="multiple-pvs-header">
        <h5>Payment Voucher - Total PVs: {total_pvs}</h5>
        <p className="text-muted">PV Code: {main_pv?.pv_code}</p>
        <p className="text-info">
          Original Amount: ₦{parseFloat(main_pv?.original_amount || 0).toLocaleString()} | 
          Net Amount: ₦{parseFloat(main_pv?.net_amount || 0).toLocaleString()}
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="pv-tabs">
        <button 
          className={`pv-tab ${activeTab === 'main' ? 'active' : ''}`}
          onClick={() => setActiveTab('main')}
        >
          Main PV (Net Amount)
        </button>
        {tax_pvs.map((taxPV, index) => (
          <button 
            key={index}
            className={`pv-tab ${activeTab === `tax-${index}` ? 'active' : ''}`}
            onClick={() => setActiveTab(`tax-${index}`)}
          >
            {taxPV.tax_name || `Tax PV ${index + 1}`}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="pv-tab-content">
        {activeTab === 'main' && (
          <div className="main-pv-content">
            <div className="main-pv-info">
              <h6>Main Payment Voucher</h6>
              <p><strong>Shows net amount after tax deductions</strong></p>
              <p>Tax details are included in the "Detailed description of service" section below</p>
            </div>
            <Trailbalance
              form={{}}
              user={user}
              data={[main_pv]}
              taxesApplied={taxes}
              isMultiplePVs={true}
              showTaxSummary={true}
            />
          </div>
        )}
        
        {tax_pvs.map((taxPV, index) => (
          activeTab === `tax-${index}` && (
            <div key={index} className="tax-pv-content">
              <div className="tax-pv-header">
                <h6>Tax Payment Voucher: {taxPV.tax_name}</h6>
                <p><strong>Amount: ₦{parseFloat(taxPV.tax_amount || 0).toLocaleString()}</strong></p>
                <p className="text-muted">This PV represents the tax deduction from the main payment</p>
              </div>
              <Trailbalance
                form={{}}
                user={user}
                data={[taxPV]}
                taxesApplied={taxPV.tax_details || []}
                isMultiplePVs={true}
                isTaxPV={true}
              />
            </div>
          )
        ))}
      </div>

      {/* Multiple PVs Styling */}
      <style jsx>{`
        .multiple-pvs-container {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 20px;
          margin-bottom: 20px;
        }
        
        .multiple-pvs-header {
          text-align: center;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #dee2e6;
        }
        
        .multiple-pvs-header h5 {
          color: #2c3e50;
          margin-bottom: 10px;
        }
        
        .pv-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          margin-bottom: 20px;
          border-bottom: 1px solid #dee2e6;
        }
        
        .pv-tab {
          background: #e9ecef;
          border: 1px solid #dee2e6;
          border-bottom: none;
          padding: 12px 16px;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
          font-weight: 500;
          transition: all 0.3s ease;
          color: #495057;
        }
        
        .pv-tab:hover {
          background: #f8f9fa;
          color: #007bff;
        }
        
        .pv-tab.active {
          background: #ffffff;
          border-color: #007bff;
          color: #007bff;
          font-weight: 600;
          box-shadow: 0 -2px 4px rgba(0,123,255,0.1);
        }
        
        .pv-tab-content {
          background: #ffffff;
          border: 1px solid #dee2e6;
          border-radius: 0 8px 8px 8px;
          padding: 20px;
          min-height: 400px;
        }
        
        .main-pv-info {
          background: #e8f4fd;
          padding: 15px;
          border-radius: 6px;
          margin-bottom: 20px;
          border-left: 4px solid #007bff;
        }
        
        .main-pv-info h6 {
          margin: 0 0 8px 0;
          color: #0056b3;
        }
        
        .main-pv-info p {
          margin: 4px 0;
          color: #495057;
        }
        
        .tax-pv-header {
          background: #fff3cd;
          padding: 15px;
          border-radius: 6px;
          margin-bottom: 20px;
          border-left: 4px solid #ffc107;
        }
        
        .tax-pv-header h6 {
          margin: 0 0 8px 0;
          color: #856404;
        }
        
        .tax-pv-header p {
          margin: 4px 0;
        }
        
        @media (max-width: 768px) {
          .pv-tabs {
            flex-direction: column;
          }
          
          .pv-tab {
            border-radius: 6px;
            border-bottom: 1px solid #dee2e6;
          }
          
          .pv-tab-content {
            border-radius: 8px;
            padding: 15px;
          }
          
          .multiple-pvs-container {
            padding: 15px;
          }
        }
      `}</style>
    </div>
  );
};

// Capital Project PV View Component
const CapitalProjectPVView = ({ capitalProjectData, user }) => {
  const [activeTab, setActiveTab] = useState('main');
  
  if (!capitalProjectData) {
    return <div>No capital project data available</div>;
  }

  const { mainPV, taxPVs = [], taxes = [], totalPVs } = capitalProjectData;

  return (
    <div className="capital-project-pv-container">
      <div className="capital-project-header">
        <h5>Capital Project PV - Total PVs: {totalPVs}</h5>
        <p className="text-muted">Main PV Code: {mainPV?.pv_code}</p>
      </div>

      {/* Tab Navigation */}
      <div className="pv-tabs">
        <button 
          className={`pv-tab ${activeTab === 'main' ? 'active' : ''}`}
          onClick={() => setActiveTab('main')}
        >
          Main PV
        </button>
        {taxPVs.map((taxPV, index) => (
          <button 
            key={index}
            className={`pv-tab ${activeTab === `tax-${index}` ? 'active' : ''}`}
            onClick={() => setActiveTab(`tax-${index}`)}
          >
            {taxes[index]?.tax_name || `Tax PV ${index + 1}`}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="pv-tab-content">
        {activeTab === 'main' && (
          <div className="main-pv-content">
            <Trailbalance
              form={{}}
              user={user}
              data={[mainPV]}
              taxesApplied={taxes}
              isCapitalProject={true}
              showTaxSummary={true}
            />
          </div>
        )}
        
        {taxPVs.map((taxPV, index) => (
          activeTab === `tax-${index}` && (
            <div key={index} className="tax-pv-content">
              <div className="tax-pv-header">
                <h6>Tax PV: {taxes[index]?.tax_name}</h6>
                <p>Amount: ₦{taxes[index]?.amount?.toLocaleString()}</p>
              </div>
              <Trailbalance
                form={{}}
                user={user}
                data={[taxPV]}
                taxesApplied={[taxes[index]]}
                isCapitalProject={true}
                isTaxPV={true}
              />
            </div>
          )
        ))}
      </div>

      {/* Capital Project Styling */}
      <style jsx>{`
        .capital-project-pv-container {
          background: #f8f9fa;
          border-radius: 8px;
          padding: 20px;
          margin-bottom: 20px;
        }
        
        .capital-project-header {
          text-align: center;
          margin-bottom: 20px;
          padding-bottom: 15px;
          border-bottom: 2px solid #dee2e6;
        }
        
        .pv-tabs {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          margin-bottom: 20px;
          border-bottom: 1px solid #dee2e6;
        }
        
        .pv-tab {
          background: #e9ecef;
          border: 1px solid #dee2e6;
          border-bottom: none;
          padding: 10px 15px;
          cursor: pointer;
          border-radius: 8px 8px 0 0;
          font-weight: 500;
          transition: all 0.3s ease;
        }
        
        .pv-tab:hover {
          background: #f8f9fa;
        }
        
        .pv-tab.active {
          background: #ffffff;
          border-color: #007bff;
          color: #007bff;
          font-weight: 600;
        }
        
        .pv-tab-content {
          background: #ffffff;
          border: 1px solid #dee2e6;
          border-radius: 0 8px 8px 8px;
          padding: 20px;
          min-height: 400px;
        }
        
        .tax-pv-header {
          background: #e3f2fd;
          padding: 15px;
          border-radius: 6px;
          margin-bottom: 20px;
          border-left: 4px solid #2196f3;
        }
        
        .tax-pv-header h6 {
          margin: 0 0 5px 0;
          color: #1976d2;
        }
        
        .tax-pv-header p {
          margin: 0;
          font-weight: 500;
          color: #424242;
        }
        
        @media (max-width: 768px) {
          .pv-tabs {
            flex-direction: column;
          }
          
          .pv-tab {
            border-radius: 6px;
            border-bottom: 1px solid #dee2e6;
          }
          
          .pv-tab-content {
            border-radius: 8px;
            padding: 15px;
          }
        }
      `}</style>
    </div>
  );
};
